"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AndroidShareOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var AndroidShareOutlineSVG = function AndroidShareOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M22 20a5 5 0 00-3.5 1.4l-4.3-2.8a4.9 4.9 0 00.1-5.1l4.3-2.9A5 5 0 0022 12a5 5 0 10-4.6-3L13 12a5 5 0 10-.1 8.1l4.5 3A5 5 0 0017 25a5 5 0 105-5zm0-16a3 3 0 11-3 3 3 3 0 013-3zM10 19a3 3 0 113-3 3 3 0 01-3 3zm12 9a3 3 0 113-3 3 3 0 01-3 3z"
  }));
};
exports.AndroidShareOutlineSVG = AndroidShareOutlineSVG;
AndroidShareOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(AndroidShareOutlineSVG);
exports.default = _default;